import { AchievementsView } from '@/components/gamification/AchievementsView';
import { TripErrorBoundary } from '@/utils/errorBoundary';

export default function AchievementsRoute() {
  return (
    <TripErrorBoundary name="GamificationAchievements">
      <AchievementsView />
    </TripErrorBoundary>
  );
}
